export const serviceLocations = ["Virtual visit", "1785 U.S. Route 9 Clifton Park, NY, 12065"];

export const serviceLocationOptions = serviceLocations.map((location) => {
  return { value: location, display: location };
});
